import { autoinject } from 'aurelia-framework';
import { QueryFilter } from 'lib/tables/DataFilter';
import { NettingTypeService, CheckDuplicateNettingTypeService } from 'models';
import { AuthHttpClient } from 'services/auth-http-client';
import { BaseApiService } from 'services/base-api-service';

@autoinject
export class NettingTypeServiceService extends BaseApiService<NettingTypeService> {
  constructor(httpClient: AuthHttpClient) {
    super(httpClient, NettingTypeService);
  }

  public getNettingTypeServiceList(filters: QueryFilter) {
    return this.httpClient.execWithResponseMeta<any[]>(`${NettingTypeService.ApiUrl}/list${filters.asQueryString}`, {
      method: 'GET',
    });
  }

  public async checkDuplicate(data: CheckDuplicateNettingTypeService) {
    return await this.httpClient.exec<{ IsDuplicate: boolean }>(`${NettingTypeService.ApiUrl}/checkDuplicate`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }
}
